import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

import type {IPropertyListItemDTO} from "@/features/properties/types/IPropertyListItemDTO";
import type {RootState} from "@/store/types/RootState";

import type {IOfferListCardTrackingMeta} from "../types/IOfferListCardTrackingMeta";

interface IOfferListCardGalleryModalState {
    isOpen: boolean;
    property: IPropertyListItemDTO | null;
    trackingMeta: IOfferListCardTrackingMeta | null;
}

interface IOpenOfferListCardGalleryModalPayload {
    property: IPropertyListItemDTO;
    trackingMeta: IOfferListCardTrackingMeta;
}

const INITIAL_STATE: IOfferListCardGalleryModalState = {
    isOpen: false,
    property: null,
    trackingMeta: null
};

export const offerListCardGalleryModalSlice = createSlice({
    initialState: INITIAL_STATE,
    name: "offerListCardGalleryModal",
    reducers: {
        closeOfferListCardGalleryModal: () => INITIAL_STATE,
        openOfferListCardGalleryModal: (_state, action: PayloadAction<IOpenOfferListCardGalleryModalPayload>) => {
            const {property, trackingMeta} = action.payload;

            return {
                isOpen: true,
                property,
                trackingMeta
            };
        }
    }
});

export const selectOfferListCardGalleryModal = (state: RootState) => state.offerListCardGalleryModal;
export const {closeOfferListCardGalleryModal, openOfferListCardGalleryModal} = offerListCardGalleryModalSlice.actions;
import {createSlice, type PayloadAction} from "@reduxjs/toolkit";

import type {IPropertyListItemDTO} from "@/features/properties/types/IPropertyListItemDTO";
import type {RootState} from "@/store/types/RootState";

import type {IOfferListCardTrackingMeta} from "../types/IOfferListCardTrackingMeta";

interface IOfferListCardGalleryModalState {
    isOpen: boolean;
    property: IPropertyListItemDTO | null;
    trackingMeta: IOfferListCardTrackingMeta | null;
}

interface IOpenOfferListCardGalleryModalPayload {
    property: IPropertyListItemDTO;
    trackingMeta: IOfferListCardTrackingMeta;
}

const INITIAL_STATE: IOfferListCardGalleryModalState = {
    isOpen: false,
    property: null,
    trackingMeta: null
};

export const offerListCardGalleryModalSlice = createSlice({
    initialState: INITIAL_STATE,
    name: "offerListCardGalleryModal",
    reducers: {
        closeOfferListCardGalleryModal: () => INITIAL_STATE,
        openOfferListCardGalleryModal: (_state, action: PayloadAction<IOpenOfferListCardGalleryModalPayload>) => {
            const {property, trackingMeta} = action.payload;

            return {
                isOpen: true,
                property,
                trackingMeta
            };
        }
    }
});

export const selectOfferListCardGalleryModal = (state: RootState) => state.offerListCardGalleryModal;
export const {closeOfferListCardGalleryModal, openOfferListCardGalleryModal} = offerListCardGalleryModalSlice.actions;
